import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({ selector: 'app-hw-obd', templateUrl: './obd-dongle.component.html', styleUrls: ['./obd-dongle.component.scss'], standalone: false })
export class OBDDongleComponent implements OnInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-chip' },
    { id: 'variants', label: 'Variants', icon: 'bx-git-branch' },
    { id: 'applications', label: 'Applications', icon: 'bx-briefcase-alt-2' },
    { id: 'how-it-works', label: 'How It Works', icon: 'bx-transfer-alt' },
    // { id: 'buy', label: 'Buy Now', icon: 'bx-cart' },
  ];
  overviewHighlights = [
    { val: 'Plug & Play', label: 'Instant OBD port activation' },
    { val: '2G / 4G', label: 'Connectivity options by deployment need' },
    { val: 'CAN / Non-CAN', label: 'Vehicle compatibility across use cases' },
  ];
  hardwareFeatures = [
    { icon: 'bx-plug', title: 'Plug & Play Design', value: 'Direct OBD port connection with no installation effort.' },
    { icon: 'bx-shield-quarter', title: 'Compact & Robust Build', value: 'Durable housing suitable for long-term field usage.' },
    { icon: 'bx-signal-4', title: 'Integrated SIM Support', value: 'Seamless connectivity with 2G and 4G-ready variants.' },
    { icon: 'bx-bulb', title: 'LED Indicators', value: 'Visual status indication for power and network connectivity.' },
    { icon: 'bx-battery', title: 'Low Power Consumption', value: 'Optimized to minimize battery usage during operation.' },
    { icon: 'bx-lock-alt', title: 'Secure Data Transmission', value: 'Built-in safeguards for safe and reliable data communication.' },
  ];
  variants = [
    { title: '2G Variant', tag: 'Cost Optimized', value: 'Suitable for basic tracking and cost-sensitive deployments.' },
    { title: '4G Variant', tag: 'High Speed', value: 'Built for real-time data transmission and faster platform sync.' },
    { title: 'CAN Compatible', tag: 'Advanced Data', value: 'Supports advanced vehicle data access via CAN protocol.' },
    { title: 'Non-CAN Compatible', tag: 'Broad Fitment', value: 'Designed for vehicles that do not expose CAN-based data.' },
  ];
  applications = [
    { icon: 'bx-buildings', title: 'OEM Integration', desc: 'Rapidly enable connected services across vehicle programs without complex installation workflows.' },
    { icon: 'bx-transfer', title: 'Fleet Management', desc: 'Track utilization, movement, exceptions, and operational efficiency across commercial fleets.' },
    { icon: 'bx-wallet', title: 'Insurance & Financing (BFSI)', desc: 'Support risk scoring, telematics-linked services, and usage-based product models.' },
    { icon: 'bx-car', title: 'Consumer Vehicle Tracking (B2C)', desc: 'Bring connected car experiences to everyday drivers through instant device onboarding.' },
    { icon: 'bx-package', title: 'Transport and Logistics (TLS)', desc: 'Extend route visibility and telemetry coverage for transport and logistics operations.' },
  ];
  howItWorks = [
    { title: 'Connect to the OBD Port', desc: 'Plug the OBD Dongle directly into the vehicle’s OBD port.' },
    { title: 'Draw Power Instantly', desc: 'The device powers on directly from the vehicle with no extra wiring.' },
    { title: 'Join the Network', desc: 'Built-in SIM connectivity brings the device online automatically.' },
    { title: 'Send Data to Platform', desc: 'Vehicle data is transmitted securely to the connected platform or application.' },
  ];
  constructor(private router: Router) {}
  ngOnInit() {}
  scrollTo(id: string) {
    if (id === 'buy') {
      this.router.navigate(['/store/product/vc-drive-smart-platinum']);
      return;
    }

    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
